<td>
  <label
    class="w-100 text-overflow-dotted"
    [ngbTooltip]="lookingForProject.employeeName"
    [openDelay]="300"
    placement="top"
    container="body"
  >
    {{ lookingForProject.employeeName }}
  </label>
</td>
<td>
  <label
    class="w-100 text-overflow-dotted"
    [ngbTooltip]="lookingForProject.companyName"
    [openDelay]="300"
    placement="top"
    container="body"
  >
    {{ lookingForProject.companyName }}
  </label>
</td>
<td>
  <select
    id="assigneeSelect"
    [(ngModel)]="editLookingForProject.assigneeId"
    (change)="handleLookingForProjectUpdate()"
    (click)="inputClicked($event)"
  >
    <option *ngFor="let user of users" [value]="user.id">
      {{ user.name }}
    </option>
  </select>
</td>
<td>
  <select
    id="statusSelect"
    [(ngModel)]="editLookingForProject.status"
    (change)="handleLookingForProjectUpdate()"
    (click)="inputClicked($event)"
  >
    <option value="WAITING">
      {{ "home.looking_for_project.status.waiting" | translate }}
    </option>
    <option value="IN_PROGRESS">
      {{ "home.looking_for_project.status.in_progress" | translate }}
    </option>
    <option value="DONE">
      {{ "home.looking_for_project.status.done" | translate }}
    </option>
  </select>
</td>
<td class="text-center">
  <fa-icon
    *ngIf="lookingForProject.comment && lookingForProject.comment !== ''"
    class="comment-icon"
    (click)="openCommentEditModal($event)"
    [icon]="['fas', 'comment']"
  ></fa-icon>
  <fa-icon
    *ngIf="!lookingForProject.comment || lookingForProject.comment === ''"
    class="comment-icon"
    (click)="openCommentEditModal($event)"
    [icon]="['far', 'comment']"
  ></fa-icon>
</td>
<td (dblclick)="setEditStateTrue('freeFrom')" class="text-center">
  <input
    *ngIf="this.editedCell === 'freeFrom'"
    type="date"
    appPrefixFocusAndSelect
    (keydown.enter)="handleLookingForProjectUpdate()"
    (keydown.escape)="setEditStateFalse()"
    (focusout)="handleLookingForProjectUpdate()"
    [(ngModel)]="editLookingForProject.freeFrom"
    (click)="inputClicked($event)"
  />
  <label
    class="text-overflow-dotted"
    [ngClass]="{ hidden: this.editedCell === 'freeFrom' }"
    [ngbTooltip]="lookingForProject.freeFrom"
    [openDelay]="300"
    placement="top"
    container="body"
  >
    {{ lookingForProject.freeFrom }}
  </label>
</td>
<td
  (dblclick)="setEditStateTrue('fte')"
  class="text-center text-overflow-dotted"
>
  <input
    id="fte"
    *ngIf="this.editedCell === 'fte'"
    type="number"
    step="0.25"
    min="0"
    max="1"
    appPrefixFocusAndSelect
    (keydown.enter)="handleLookingForProjectUpdate()"
    (keydown.escape)="setEditStateFalse()"
    (focusout)="handleLookingForProjectUpdate()"
    [(ngModel)]="editLookingForProject.fte"
    (click)="inputClicked($event)"
  />
  <label id="fteLabel" *ngIf="this.editedCell !== 'fte'">
    {{ editLookingForProject.fte | number:'1.2-2' }}
  </label>
</td>
<td>
  <label *ngIf="!lookingForProject.seniority">---</label>
  <label *ngIf="lookingForProject.seniority" class="text-overflow-dotted">
    {{
      "home.looking_for_project.seniority." + lookingForProject.seniority
        | translate
    }}
  </label>
</td>
<td>
  <label
    class="w-100 text-overflow-dotted"
    [ngbTooltip]="lookingForProject.positionName"
    [openDelay]="300"
    placement="top"
    container="body"
  >
    {{ lookingForProject.positionName }}
  </label>
</td>
<td class="text-center">
  <fa-icon
    class="cv-icon"
    [icon]="['fas', 'file']"
    (click)="openReadOnlyProfile(lookingForProject.employeeId)"
  ></fa-icon>
</td>
